import { wsService } from "./wsService";
const api_url = process.env.VUE_APP_API_URL;
const section = "ubicaciones";
import axios from "axios";

const LIBRE = 'L';
const STOCK = 'S';//Tiene stock, hay productos pero aun hay volumen libre
const LLENA = 'F';//Ocupado es que esta lleno
const BLOQUEADO = 'B';//No se puede sacar ni poner nada
const CUARENTENA = 'C';
const BLOQUEADO_CONTEO = 'K';//Bloqueada por un conteo de stock abierto, la libera el conteo al cerrarse

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function performeAction(params){
  return wsService.make_post_request(section + "/performe-action", params);
}

function getStates(){
  return wsService.make_get_request(section + "/get-states");
}

function print(param = {}, type) {
  var url = "";
  if (type == "zpl") {
    url = section + "/print/label/bulk/termica_zpl";
  }
  if (type == "pdf") {
    url = section + "/print/label/bulk/termica_pdf";
  }
  const token = localStorage.getItem("token");
  return axios.post(api_url + url, param, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/pdf",
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + token,
    },
  }).catch((error)=>{    console.error("Network Error:", error);
  });
}

function ubicationValidateScan(params){
  return wsService.make_post_request(section + "/validate", params);
}

export const ubicacionService = {
  section,
  filter,
  remove,
  create,
  update,
  print,
  performeAction,
  getStates,
  ubicationValidateScan,
  LIBRE,
  STOCK,
  LLENA,
  BLOQUEADO,
  CUARENTENA,
  BLOQUEADO_CONTEO
};
